import LegalPage from "../components/LegalPage/LegalPage";
import legalDocuments from "../content/legalDocuments";
import { useLanguage } from "../contexts/LanguageContext";

const TermsOfService = () => {
  const { language } = useLanguage();
  const document = legalDocuments[language] || legalDocuments.en;

  return <LegalPage kind="terms" {...document.terms} />;
};

export default TermsOfService;
